module.exports = __webpack_public_path__ + "img/icon-emote4.4223b137.svg";